export enum RevenueRecognitionType {
  RevenueEqualsBilled = "REVENUE_EQUALS_BILLED",
  PercentageCompletion = "PERCENTAGE_OF_COMPLETION",
  CompletedContract = "COMPLETED_CONTRACT"
}
